import React from "react";

import { ReportLink } from "../shared/SectionCard";

import {

  AdminHomeCustomIcon,

  IntegrationChipIcon,

} from "../shared/adminHomeIcons";

import type {

  IntegrationBreakdown,

  IntegrationOverviewData,

} from "../../types";



type IntegrationMetricCellProps = {

  value: number;

  breakdown: IntegrationBreakdown[];

};



const MAX_PILLS_PER_ROW = 3;

const chunkBreakdown = (
  breakdown: IntegrationBreakdown[],
  size: number
): IntegrationBreakdown[][] => {
  const rows: IntegrationBreakdown[][] = [];

  for (let index = 0; index < breakdown.length; index += size) {
    rows.push(breakdown.slice(index, index + size));
  }

  return rows;
};

const IntegrationMetricCell: React.FC<IntegrationMetricCellProps> = ({
  value,
  breakdown,
}) => {
  const pillRows = chunkBreakdown(breakdown, MAX_PILLS_PER_ROW);

  return (
  <div className="admin-home-integration__metric">

    <div className="admin-home-integration__metric-main">

      <strong>{value}</strong>

      <span className="admin-home-integration__metric-label">

        Total Integration

      </span>

    </div>

    <div className="admin-home-integration__pills">
      {pillRows.map((row, rowIndex) => (
        <div
          key={`${row.map((item) => item.label).join("-")}-${rowIndex}`}
          className="admin-home-integration__pills-row"
        >
          {row.map((item) => (
            <span key={item.label} className="admin-home-integration__pill">
              {item.label} : {item.value}
            </span>
          ))}
        </div>
      ))}
    </div>

  </div>
  );
};



type IntegrationOverviewCardProps = {
  data: IntegrationOverviewData;
  onViewIntegrationStatus?: () => void;
  onViewReport?: () => void;
};

const IntegrationOverviewCard: React.FC<IntegrationOverviewCardProps> = ({
  data,
  onViewIntegrationStatus,
  onViewReport,
}) => {

  const { rows, status } = data;



  return (

    <section className="admin-home-integration">

      <div className="admin-home-integration__header">

        <div className="admin-home-integration__title-block">

          <span className="admin-home-integration__header-icon">

            <IntegrationChipIcon width={24} height={24} />

          </span>

          <div className="admin-home-integration__header-text">

            <h3 className="admin-home-integration__title">Integration Overview</h3>

            <p className="admin-home-integration__subtitle">

              Real-time system integration metrics

            </p>

          </div>

        </div>

      </div>



      <div className="admin-home-integration__content">

        <div className="admin-home-integration__table-wrap">

          <table className="admin-home-integration__table">
            <colgroup>
              <col className="admin-home-integration__col-tech" />
              <col className="admin-home-integration__col-metric" />
              <col className="admin-home-integration__col-metric" />
              <col className="admin-home-integration__col-metric" />
            </colgroup>

            <thead>

              <tr>

                <th>Technology Stack</th>

                <th>In Progress</th>

                <th>Completed</th>

                <th>Avg Duration (Days)</th>

              </tr>

            </thead>

            <tbody>

              {rows.length > 0 ? (
                rows.map((row) => (

                <tr key={row.id}>

                  <td>

                    <span className="admin-home-integration__tech">

                      <span className="admin-home-integration__tech-icon">

                        <AdminHomeCustomIcon

                          name={row.customIcon}

                          width={24}

                          height={24}

                        />

                      </span>

                      <span className="admin-home-integration__tech-name">

                        {row.technology}

                      </span>

                    </span>

                  </td>

                  <td>

                    <IntegrationMetricCell

                      value={row.inProgress}

                      breakdown={row.inProgressBreakdown}

                    />

                  </td>

                  <td>

                    <IntegrationMetricCell

                      value={row.completed}

                      breakdown={row.completedBreakdown}

                    />

                  </td>

                  <td>

                    <div className="admin-home-integration__duration">

                      <div className="admin-home-integration__duration-main">

                        <strong>{row.avgDurationDays}</strong>

                        <span>days</span>

                      </div>

                      <div className="admin-home-integration__duration-pills">

                        <span className="admin-home-integration__duration-pill">

                          Min: {row.minDays}

                        </span>

                        <span className="admin-home-integration__duration-pill">

                          Max: {row.maxDays}

                        </span>

                      </div>

                    </div>

                  </td>

                </tr>

              ))
              ) : (
                <tr>
                  <td colSpan={4} className="admin-home-integration__empty">
                    No integration overview data available.
                  </td>
                </tr>
              )}

            </tbody>

          </table>

        </div>



        <aside className="admin-home-integration__status">

          <h4 className="admin-home-integration__status-title">

            Integration Status

          </h4>

          <div className="admin-home-integration__status-item">

            <span className="admin-home-integration__status-label">

              Overall Completed

            </span>

            <span className="admin-home-integration__status-total">TOTAL</span>

            <strong>{status.overallCompleted.toLocaleString("en-US")}</strong>

          </div>

          <div className="admin-home-integration__status-item">

            <span className="admin-home-integration__status-label">

              Live Validation

            </span>

            <span className="admin-home-integration__status-total">TOTAL</span>

            <strong>{status.liveValidation.toLocaleString("en-US")}</strong>

          </div>

          <div className="admin-home-integration__status-item">

            <span className="admin-home-integration__status-label">

              In Progress

            </span>

            <span className="admin-home-integration__status-total">TOTAL</span>

            <strong>{status.inProgress.toLocaleString("en-US")}</strong>

          </div>

        </aside>



        <div className="admin-home-integration__footer">
          <ReportLink
            label="View Integration Status"
            onClick={onViewIntegrationStatus}
            disabled={false}
          />
          <ReportLink
            label="View Integration Report"
            onClick={onViewReport}
          />
        </div>

      </div>

    </section>

  );

};



export default IntegrationOverviewCard;

